import { Component, Input, inject } from "@angular/core";
import { ThirdPartyModel } from "@models/thirdparty/ThirdpartyModel";
import { ControlLinkModel } from "@models/controls/ControlLinkModel";
import { ControlDataService } from "@app/controls/services/control.data.service";
import { ModuleType } from "@enums/ModuleType";

@Component({
    selector: "thirdparty-controls",
    templateUrl: "./thirdparty-controls.component.html",
    styleUrls: ["./thirdparty-controls.component.scss"],
    standalone: false
})
export class ThirdPartyControlsComponent {
    private _controlDataService = inject(ControlDataService);

    @Input() model: ThirdPartyModel;
    @Input() disabled = false;

    linked: ControlLinkModel[];
    unlinked: ControlLinkModel[];
    isLoading = true;

    load() {
        if (!this.model) {
            return;
        }

        this._controlDataService
            .getLinkableControls(ModuleType.TP, this.model.ID, this.model.OrganizationResponsibleId)
            .subscribe((value) => {
                this.loadData(this.model.LinkedControls, value.sortBy("name", true));
                this.isLoading = false;
            });
    }
    linkedChanged(newList: ControlLinkModel[]) {
        this.model.LinkedControls = newList.map((x) => x.id);
    }

    private loadData(linkedIds: number[], items: ControlLinkModel[]) {
        const linked = [],
            unlinked = [];

        for (const item of items) {
            if (linkedIds.indexOf(item.id) >= 0) {
                linked.push(item);
            } else {
                unlinked.push(item);
            }
        }
        this.linked = linked;
        this.unlinked = unlinked;
    }
}
